module.exports = __webpack_public_path__ + "static/media/creditas.a9e5ddec.svg";